module.exports = __webpack_public_path__ + "img/Albania.48989ca4.svg";